import React from 'react';
import { Link } from 'react-router-dom';
export function NoviLinks() {
  return <section className="py-12 bg-subtle-gray/30 text-center" data-id="element-2692">
      <div className="max-w-4xl mx-auto px-4" data-id="element-2693">
        <p className="text-gray-warm font-bold mb-4 uppercase tracking-wide" data-id="element-2694">
          Also Serving Nearby Communities
        </p>
        <div className="flex flex-wrap justify-center gap-4" data-id="element-2695">
          {['Farmington Hills', 'Commerce', 'Walled Lake', 'Northville'].map((area, idx) => <Link key={idx} to={`/${area.toLowerCase().replace(/\s+/g, '-')}-martial-arts`} className="text-ink hover:text-storm-red transition-colors font-medium" data-id="element-2696">
                {area}
              </Link>)}
        </div>
      </div>
    </section>;
}